<footer>
  <div class="left-shape">
    <div class="rectangle">
      <div class="footer-text">{{uiUrl}}</div>
    </div>
    <div class="triangle"></div>
  </div>
  <div class="right-shape">
    <div class="incomplete-line-hider"></div>
    <div class="lines"></div>
  </div>
</footer>
